module.exports = __webpack_public_path__ + "static/media/w5.ddff7696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/w5.jpg
// module id = 312
// module chunks = 0